import { Component } from 'react';

export class SidebarPersistentFooter extends Component {
  render() {
    return this.props.children;
  }
}
